// 2023/12/25 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
import { FC, useCallback, useState, Key, useMemo, useEffect, ChangeEvent } from 'react';
import { useAppDispatch } from 'hooks';
import { useSelector } from 'react-redux';
import { Checkbox, Pagination } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import ButtonSubmit from 'components/Forms/ButtonSubmit';
import { InputField, CheckboxField, Table, Button, Modal } from 'components';
import { FormikProvider, useFormik } from 'formik';
import { userData } from 'pages/Login/selectors';
import { Form } from 'formik-antd';
import * as Types from 'types';
import { SupportSite, userRole } from 'constant';
import { educationService } from 'services';
import { ContentStyled } from 'pages/ModalMock/ApproveRY/styles';
import { EducationStatusStyled } from './styles';
import { educationStatusData } from './selectors';
import { actions } from './slice';
import { educationStatusList, educationApprovalRegister } from './thunk';

const EducationStatus: FC = () => {
  const pageSize = 10;
  const dispatch = useAppDispatch();
  const location = useLocation();
  const params: any = location.state;
  let send_image_flg: any = null;
  if (params && params.send_image_flg) {
    send_image_flg = params.send_image_flg;
  }
  const history = useHistory();
  const { user_id, roleUser } = useSelector(userData);
  const [currentSent, setCurrentSent] = useState(1);
  const [allFlg, setAllFlg] = useState<boolean>(false);
  const [allFlgDis, setAllFlgDis] = useState<boolean>(false);
  const [visibleApproveRY, setVisibleApproveRY] = useState<boolean>(false);
  const [checkAppro, setCheckAppro] = useState<boolean>(false);
  const [selectPopu, setSelectPopu] = useState<boolean>(false);
  const [buttonFlg, setButtonFlg] = useState<boolean>(true);
  const [appButtonFlg, setAppButtonFlg] = useState<boolean>(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([]);
  const [pageKey, setPageKey] = useState<string[]>([]);
  const [dataSource, setDataSource] = useState<Types.EducationStatusInfoType[]>([]);
  const [dataSourceShow, setDataSourceShow] = useState<Types.EducationStatusInfoType[]>([]);
  const { search_info, education_status_list, rKey, error } = useSelector(educationStatusData);
  const [jyuchucodeValue, setJyuchucodeValue] = useState<string>('');
  const [gyosyasitencodeValue, setGyosyasitencodeValue] = useState<string>('');
  const [tsuikacodeValue, setTsuikacodeValue] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  // 初期化時にデータを取得する
  useEffect(() => {
    // 画面の初期化時にのみ実行されるように確認してください。
    if (education_status_list) return;
    // 検索条件が存在することを確認してください。
    if (!user_id) return;
    dispatch(educationStatusList({ userId: user_id }));
  }, [dispatch, user_id]);

  //データの表示
  useEffect(() => {
    // データが検索されない場合は実行しないようにしてください。
    if (!education_status_list) return;
    // 1ページあたりの最大数に基づいて、最初の10件を取得してください。
    const firstArray = education_status_list.slice(0, 10);
    // 取得したデータを保存して、クエリの際に使用できるようにしてください。
    setDataSource(education_status_list);
    // 現在のページに表示されているデータ
    setDataSourceShow(firstArray);
    // 現在のページのすべてのデータのキー値を取得する
    setPageKey(
      firstArray
        .filter((item) => item.newcomer_education_status != 2 || item.sendoff_education_status != 2)
        .map(({ users_id, site_id }) => `${site_id}${users_id}`)
    );
    // 全選ボタンの状態を設定する
    setAllFlg(false);
    // データを再取得した後、確実に1ページ目になっていることを確認してください。
    if (currentSent != 1) {
      setCurrentSent(1);
    }
  }, [education_status_list]);

  //エラーメッセージを表示
  useEffect(() => {
    // エラーメッセージを取得した場合、エラーメッセージを設定してください。
    setErrorMessage(error);
    // エラーメッセージがある場合、表示してください。
    if (error != '') {
      setVisibleApproveRY(false);
      setErrorFlag(true);
    } else {
      // エラーメッセージがない場合、情報ボックスを非表示にしてください。
      setErrorFlag(false);
    }
  }, [error]);

  //以前にクエリー条件があった場合は、クエリーを実行します。
  const checkInfo = () => {
    // 以前の検索条件があるかどうかを判断してください。
    if (search_info) {
      // 検索条件をフォームに割り当ててください。
      formik.setFieldValue('newCheNot', search_info.newcomer_check_notimpl);
      formik.setFieldValue('newCheImp', search_info.newcomer_check_impl);
      formik.setFieldValue('newCheApp', search_info.newcomer_check_approved);
      formik.setFieldValue('sendCheNot', search_info.sendoff_check_notimpl);
      formik.setFieldValue('sendCheImp', search_info.sendoff_check_impl);
      formik.setFieldValue('sendCheApp', search_info.sendoff_check_approved);
      formik.setFieldValue('gyosyacode', search_info.gyosya_code);
      if (search_info.gyosya_siten_code && search_info.gyosya_siten_code != '') {
        setGyosyasitencodeValue(search_info.gyosya_siten_code);
      }
      formik.setFieldValue('companyname', search_info.company_name);
      formik.setFieldValue('workername', search_info.worker_name);
      if (search_info.jyuchu_code && search_info.jyuchu_code != '') {
        setJyuchucodeValue(search_info.jyuchu_code);
      }
      if (search_info.tsuika_code && search_info.tsuika_code != '') {
        setTsuikacodeValue(search_info.tsuika_code);
      }
      formik.setFieldValue('sitename', search_info.site_name);
      // 検索条件のセットを定義してください。
      let search = {};
      const newFlg = [] as number[];
      const sendFlg = [] as number[];
      // 検索条件が存在するかどうかに応じて、検索条件を分類して保存してください。
      if (search_info.newcomer_check_notimpl) {
        newFlg.push(0);
      }
      if (search_info.newcomer_check_impl) {
        newFlg.push(1);
      }
      if (search_info.newcomer_check_approved) {
        newFlg.push(2);
      }
      if (search_info.sendoff_check_notimpl) {
        sendFlg.push(0);
      }
      if (search_info.sendoff_check_impl) {
        sendFlg.push(1);
      }
      if (search_info.sendoff_check_approved) {
        sendFlg.push(2);
      }
      if (search_info.gyosya_code != '') {
        search = {
          ...search,
          gyosya_code: search_info.gyosya_code,
        };
      }
      if (search_info.gyosya_siten_code != '') {
        search = {
          ...search,
          gyosya_siten_code: search_info.gyosya_siten_code,
        };
      }
      if (search_info.company_name != '') {
        search = {
          ...search,
          company_name: search_info.company_name,
        };
      }
      if (search_info.worker_name != '') {
        search = {
          ...search,
          worker_name: search_info.worker_name,
        };
      }
      if (search_info.jyuchu_code != '') {
        search = {
          ...search,
          jyuchu_code: search_info.jyuchu_code,
        };
      }
      if (search_info.tsuika_code != '') {
        search = {
          ...search,
          tsuika_code: search_info.tsuika_code,
        };
      }
      if (search_info.site_name != '') {
        search = {
          ...search,
          site_name: search_info.site_name,
        };
      }
      if (!education_status_list) return;
      // 一時的な配列
      let midData: Types.EducationStatusInfoType[] = [];
      // データをフィルタリングする
      if (newFlg.length > 0) {
        midData = education_status_list.filter((item) => {
          return newFlg.includes(item.newcomer_education_status);
        });
      }
      if (newFlg.length > 0 && sendFlg.length > 0) {
        midData = midData.filter((item) => {
          return sendFlg.includes(item.sendoff_education_status);
        });
      } else if (sendFlg.length > 0) {
        midData = education_status_list.filter((item) => {
          return sendFlg.includes(item.sendoff_education_status);
        });
      }
      if (newFlg.length > 0 || sendFlg.length > 0) {
        midData = midData.filter((item) => {
          return Object.entries(search).every(([key, value]) => {
            if (key === 'site_name' || key === 'worker_name' || key === 'company_name') {
              return (item as any)[key].includes(value);
            } else {
              return (item as any)[key] === value;
            }
          });
        });
      } else {
        midData = education_status_list.filter((item) => {
          return Object.entries(search).every(([key, value]) => {
            if (key === 'site_name' || key === 'worker_name' || key === 'company_name') {
              return (item as any)[key].includes(value);
            } else {
              return (item as any)[key] === value;
            }
          });
        });
      }
      // データに値を割り当てる
      setDataSource(midData);
      setDataSourceShow(midData.slice(0, 10));
      setPageKey(
        midData
          .slice(0, 10)
          .filter(
            (item) => item.newcomer_education_status != 2 || item.sendoff_education_status != 2
          )
          .map(({ users_id, site_id }) => `${site_id}${users_id}`)
      );
      if (rKey) {
        setSelectedRowKeys(rKey);
      }
    }
  };

  //他のページから戻る場合
  useEffect(() => {
    if (!user_id || !send_image_flg) return;
    if (+send_image_flg === 1) {
      dispatch(educationStatusList({ userId: user_id }));
      dispatch(actions.removeSearchInfo());
    } else {
      checkInfo();
    }
  }, [dispatch, user_id, send_image_flg]);

  //データ検索
  const formik = useFormik({
    initialValues,
    async onSubmit(values) {
      setSelectedRowKeys([]);
      values.jyuchucode = jyuchucodeValue;
      values.gyosyasitencode = gyosyasitencodeValue;
      values.tsuikacode = tsuikacodeValue;
      const searchInfo: Types.educationSearchInfo = {
        newcomer_check_notimpl: values.newCheNot,
        newcomer_check_impl: values.newCheImp,
        newcomer_check_approved: values.newCheApp,
        sendoff_check_notimpl: values.sendCheNot,
        sendoff_check_impl: values.sendCheImp,
        sendoff_check_approved: values.sendCheApp,
        gyosya_code: values.gyosyacode,
        gyosya_siten_code: values.gyosyasitencode,
        company_name: values.companyname,
        worker_name: values.workername,
        jyuchu_code: values.jyuchucode,
        tsuika_code: values.tsuikacode,
        site_name: values.sitename,
      };
      // 検索条件を保存する
      await dispatch(actions.setSearchInfo(searchInfo));
      if (!education_status_list) return;
      let midData: Types.EducationStatusInfoType[] = [];
      let search = {};
      const newFlg = [] as number[];
      const sendFlg = [] as number[];
      if (values.newCheNot) {
        newFlg.push(0);
      }
      if (values.newCheImp) {
        newFlg.push(1);
      }
      if (values.newCheApp) {
        newFlg.push(2);
      }
      if (values.sendCheNot) {
        sendFlg.push(0);
      }
      if (values.sendCheImp) {
        sendFlg.push(1);
      }
      if (values.sendCheApp) {
        sendFlg.push(2);
      }
      if (values.gyosyacode != '') {
        search = {
          ...search,
          gyosya_code: values.gyosyacode,
        };
      }
      if (values.gyosyasitencode != '') {
        search = {
          ...search,
          gyosya_siten_code: values.gyosyasitencode,
        };
      }
      if (values.companyname != '') {
        search = {
          ...search,
          company_name: values.companyname,
        };
      }
      if (values.workername != '') {
        search = {
          ...search,
          worker_name: values.workername,
        };
      }
      if (values.jyuchucode != '') {
        search = {
          ...search,
          jyuchu_code: values.jyuchucode,
        };
      }
      if (values.tsuikacode != '') {
        search = {
          ...search,
          tsuika_code: values.tsuikacode,
        };
      }
      if (values.sitename != '') {
        search = {
          ...search,
          site_name: values.sitename,
        };
      }
      if (newFlg.length > 0) {
        midData = education_status_list.filter((item) => {
          return newFlg.includes(item.newcomer_education_status);
        });
      }
      if (newFlg.length > 0 && sendFlg.length > 0) {
        midData = midData.filter((item) => {
          return sendFlg.includes(item.sendoff_education_status);
        });
      } else if (sendFlg.length > 0) {
        midData = education_status_list.filter((item) => {
          return sendFlg.includes(item.sendoff_education_status);
        });
      }

      if (newFlg.length > 0 || sendFlg.length > 0) {
        midData = midData.filter((item) => {
          return Object.entries(search).every(([key, value]) => {
            if (key === 'site_name' || key === 'worker_name' || key === 'company_name') {
              return (item as any)[key].includes(value);
            } else {
              return (item as any)[key] === value;
            }
          });
        });
      } else {
        midData = education_status_list.filter((item) => {
          return Object.entries(search).every(([key, value]) => {
            if (key === 'site_name' || key === 'worker_name' || key === 'company_name') {
              return (item as any)[key].includes(value);
            } else {
              return (item as any)[key] === value;
            }
          });
        });
      }

      setDataSource(midData);
      setDataSourceShow(midData.slice(0, 10));
      setPageKey(
        midData
          .slice(0, 10)
          .filter(
            (item) => item.newcomer_education_status != 2 || item.sendoff_education_status != 2
          )
          .map(({ users_id, site_id }) => `${site_id}${users_id}`)
      );
      if (midData.length === 0) {
        setSelectPopu(true);
        setAllFlgDis(true);
      } else {
        setAllFlgDis(false);
      }
    },
  });

  //各データにキーを設定する
  const rowKey = useCallback(({ site_id, users_id }) => {
    return `${site_id}${users_id}`;
  }, []);
  // 要求に基づいて、入力された値を制限する
  const jyuchucodeChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    // 数字でなければなりません
    const numericValue = value.replace(/\D/g, '');
    // 最大7桁
    if (numericValue.length <= 7) {
      setJyuchucodeValue(numericValue);
    }
  };
  const gyosyasitencodeChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    // 数字でなければなりません
    const numericValue = value.replace(/\D/g, '');
    // 最大3桁
    if (numericValue.length <= 3) {
      setGyosyasitencodeValue(numericValue);
    }
  };
  const tsuikacodeChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const numericValue = value.replace(/\D/g, '');
    if (numericValue.length <= 3) {
      setTsuikacodeValue(numericValue);
    }
  };
  //テーブルのヘッダー
  const columns = [
    {
      title: '業者コード',
      dataIndex: 'cooperator_code',
      width: '8%',
      render: (cooperator_code: string) => <div className="colunmSty">{cooperator_code}</div>,
    },
    {
      title: '業者名',
      dataIndex: 'company_name',
      width: '18%',
      render: (company_name: string) => <div className="colunmSty txtSet">{company_name}</div>,
    },
    {
      title: '作業員名',
      dataIndex: 'worker_name',
      width: '10%',
      render: (worker_name: string) => <div className="txtSet colunmSty">{worker_name}</div>,
    },
    {
      title: '年齢',
      dataIndex: 'age',
      className: 'boder-center',
      width: '5%',
    },
    {
      title: '現場コード',
      dataIndex: 'site_code',
      width: '8%',
      render: (site_code: string) => <div className="colunmSty">{site_code}</div>,
    },
    {
      title: '現場名',
      dataIndex: 'site_name',
      width: '18%',
      render: (site_name: string) => <div className="colunmSty txtSet">{site_name}</div>,
    },
    {
      title: '初回入場日',
      dataIndex: 'new_admission',
      render: (new_admission: string) => <div className="colunmSty">{new_admission}</div>,
    },
    {
      title: '新規入場者教育',
      className: 'boder-center',
      render: (iteam: Types.EducationStatusInfoType) => {
        if (iteam.newcomer_education_status == 0) {
          return (
            <a href="" onClick={(event) => newPush(iteam, true, event)} className="aStyle">
              未実施
            </a>
          );
        } else if (iteam.newcomer_education_status == 1) {
          return (
            <a href="" onClick={(event) => newPush(iteam, true, event)} className="aStyle">
              実施済
            </a>
          );
        } else {
          return <span>承認済</span>;
        }
      },
    },
    {
      title: '送り出し教育',
      className: 'boder-center',
      render: (iteam: Types.EducationStatusInfoType) => {
        if (iteam.sendoff_education_status == 0) {
          return (
            <a href="" onClick={(event) => newPush(iteam, false, event)} className="aStyle">
              未実施
            </a>
          );
        } else if (iteam.sendoff_education_status == 1) {
          return (
            <a href="" onClick={(event) => newPush(iteam, false, event)} className="aStyle">
              実施済
            </a>
          );
        } else {
          return <span>承認済</span>;
        }
      },
    },
  ];
  //全選ボタン
  const handleCheck = () => {
    // 全選ボタンが選択状態です。
    if (allFlg) {
      // 未選択に設定する
      setAllFlg(false);
      // 選択されたデータをクリアする
      setSelectedRowKeys([]);
      // 保存
      dispatch(actions.setRowKey([]));
    } else {
      // 全選ボタンが選択状態です
      setAllFlg(true);
      // 現在のページで条件に合致するデータのキーを保存する
      setSelectedRowKeys(
        dataSourceShow
          .filter(
            (item) => item.newcomer_education_status != 2 || item.sendoff_education_status != 2
          )
          .map(({ users_id, site_id }) => `${site_id}${users_id}`)
      );
      // 保存
      dispatch(actions.setRowKey(selectedRowKeys));
    }
  };
  //ボタンが有効かどうか判断する
  const isRowDisabled = (record: Types.EducationStatusInfoType) => {
    if (record.newcomer_education_status === 2 && record.sendoff_education_status === 2) {
      return true;
    } else {
      return false;
    }
  };
  //ページボタン
  const setCurrent = (page: number) => {
    // ページを切り替える際に選択したデータをクリアする
    setAllFlg(false);
    setSelectedRowKeys([]);
    dispatch(actions.setRowKey([]));
    setCurrentSent(page);
    // ページを切り替えた後のデータを設定する
    const infoArray = dataSource.slice((page - 1) * 10, page * 10);
    setDataSourceShow(infoArray);
    setPageKey(
      infoArray
        .filter((item) => item.newcomer_education_status != 2 || item.sendoff_education_status != 2)
        .map(({ users_id, site_id }) => `${site_id}${users_id}`)
    );
  };
  // 新規・送出ボタン
  const toNewentrantSendoff = useCallback(async () => {
    // 選択されたキーに基づいて、選択したデータをフィルタリングする
    const selectData = dataSourceShow.filter((item) => {
      return selectedRowKeys.some((t) => t === `${item.site_id}${item.users_id}`);
    });
    // ページ遷移のためのパラメータを設定する
    const checkData: any = await Promise.all(
      selectData.map(async (eduItem) => {
        return {
          users_id: +eduItem.users_id,
          cooperator_code: eduItem.cooperator_code,
          worker_name: eduItem.worker_name,
          site_id: +eduItem.site_id,
          site_code: eduItem.site_code,
        };
      })
    );
    // ページ遷移
    history.push({
      pathname: SupportSite.NEW_ENTRANTSENDOFF,
      state: { worker_datas: checkData },
    });
  }, [selectedRowKeys, user_id, dispatch]);
  // 新規入場日教育・送り出し教育ボタン
  const newPush = useCallback((data: Types.EducationStatusInfoType, flag: boolean, event: any) => {
    // ハイパーリンクのデフォルトのリフレッシュ動作を無効にする
    event.preventDefault();
    // 異なるパラメータに基づいて、ページ遷移のパラメータを設定する
    if (flag) {
      const entity: any = {
        ...data,
        education_difference: '1',
      };
      history.push({
        pathname: SupportSite.SendPhoto,
        state: { education_status: entity },
      });
    } else {
      const entity: any = {
        ...data,
        education_difference: '2',
      };
      history.push({
        pathname: SupportSite.SendPhoto,
        state: { education_status: entity },
      });
    }
  }, []);
  // データの選択ロジック
  const rowSelection = useMemo(
    () => ({
      // データのキーが格納されている配列
      selectedRowKeys,
      // データの状態変化のロジック
      onChange: (rowKeys: Key[]) => {
        // 変更後のキーの配列を保存する
        setSelectedRowKeys(rowKeys);
        // 保存
        dispatch(actions.setRowKey(rowKeys));
        // 選択された後のキーの配列の長さが、現在のページのすべてのキーの数と同じであれば、全選ボタンはデフォルトで選択された状態になります。
        if (pageKey.length != rowKeys.length) {
          setAllFlg(false);
        } else {
          setAllFlg(true);
        }
      },
      // ボックスをクリックして初期化されたときの状態確認
      getCheckboxProps: (record: Types.EducationStatusInfoType) => ({
        // 条件に合致する場合、デフォルトではクリックできません。
        disabled: isRowDisabled(record),
      }),
    }),
    [dispatch, selectedRowKeys, pageKey]
  );
  // データが選択された後、ボタンの状態を判断します。
  useEffect(() => {
    if (selectedRowKeys.length > 0) {
      // 選択されたデータを検索する
      const selectData = dataSourceShow.filter((item) => {
        return selectedRowKeys.some((t) => t === `${item.site_id}${item.users_id}`);
      });
      // 選択されたデータが条件を満たしているかどうかを判断する
      const flg = selectData.some((list) => {
        return list.newcomer_education_status != 1 && list.sendoff_education_status != 1;
      });
      setAppButtonFlg(flg);
      setButtonFlg(false);
    } else {
      setAppButtonFlg(true);
      setButtonFlg(true);
    }
  }, [selectedRowKeys.length]);

  //承認ボタン
  const approveButton = useCallback(async () => {
    // 選択されたデータを検索する
    const selectData = dataSourceShow.filter((item) => {
      return selectedRowKeys.some((t) => t === `${item.site_id}${item.users_id}`);
    });
    let item_check: number = 1;
    // データをループし、データの値を再取得する
    const checkData: any = await Promise.all(
      selectData.map(async (eduItem) => {
        const result = await educationService.getEducationStatus({
          user_id: +eduItem.users_id,
          cooperator_code: eduItem.cooperator_code,
          site_id: eduItem.site_id,
        });
        if (item_check === 1) {
          if (
            result.data.newcomer_education_status === 2 &&
            result.data.sendoff_education_status === 2
          ) {
            item_check = 0;
          }
        }
        return {
          ...eduItem,
          newcomer_education_status: result.data.newcomer_education_status,
          sendoff_education_status: result.data.sendoff_education_status,
        };
      })
    );
    // 条件に合致する場合、ポップアップを表示する
    if (item_check === 0) {
      setVisibleApproveRY(false);
      setCheckAppro(true);
      if (!user_id) return;
      dispatch(educationStatusList({ userId: user_id }));
      formik.resetForm();
      setSelectedRowKeys([]);
      return null;
    }
    // APIのパラメータを設定する
    const queryData: Types.EducationUserInfoType[] = checkData.map((item: any) => {
      return {
        user_sid: item.users_id,
        cooperator_code: item.cooperator_code,
        site_id: `${item.site_id}`,
        newcomer_education_status: `${item.newcomer_education_status}`,
        sendoff_education_status: `${item.sendoff_education_status}`,
      };
    });
    if (!user_id) return;
    // APIを実行する
    const result = await dispatch(
      educationApprovalRegister({
        user_id: user_id,
        users: queryData,
      })
    );
    // APIの実行が成功した場合
    if (educationApprovalRegister?.fulfilled?.match(result)) {
      dispatch(educationStatusList({ userId: user_id }));
      formik.resetForm();
      setSelectedRowKeys([]);
      setVisibleApproveRY(false);
    }
  }, [selectedRowKeys, user_id, dispatch]);

  return (
    <EducationStatusStyled>
      <Modal
        title={
          <div
            className="appPopuSty"
            dangerouslySetInnerHTML={{ __html: errorMessage.replace(/\n/g, '<br>') }}
          ></div>
        }
        visible={errorFlag}
        width={640}
        okButton={{
          text: '閉じる',
          onClick: async () => {
            setErrorFlag(false);
            setErrorMessage('');
            dispatch(actions.removeError());
            if (!user_id) return;
            dispatch(educationStatusList({ userId: user_id }));
            formik.resetForm();
            setSelectedRowKeys([]);
            setVisibleApproveRY(false);
          },
        }}
      ></Modal>
      <Modal
        title={
          <div className="appPopuSty">
            選択した「新規入場・送出教育」を承認します。よろしいですか？
          </div>
        }
        visible={visibleApproveRY}
        width={640}
        okButton={{
          text: '承認',
          onClick: async () => {
            approveButton();
          },
        }}
        cancelButton={{
          text: 'キャンセル',
          onClick: () => {
            setVisibleApproveRY(false);
          },
        }}
      >
        <ContentStyled>この操作は元に戻せません</ContentStyled>
      </Modal>
      <Modal
        title={
          <div className="appPopuSty">
            新規入場者教育、送り出し教育が既に承認済みの作業員が存在する為、実施することが出来ません。
          </div>
        }
        visible={checkAppro}
        width={640}
        okButton={{
          text: '閉じる',
          onClick: async () => {
            setCheckAppro(false);
          },
        }}
      ></Modal>
      <Modal
        title={
          <div className="appPopuSty">
            <div>該当の検索結果が存在しません。</div>
            <div className="appPopuSty">検索条件の内容を見直してください。</div>
          </div>
        }
        visible={selectPopu}
        width={640}
        okButton={{
          text: '閉じる',
          onClick: async () => {
            setSelectPopu(false);
          },
        }}
      ></Modal>
      <div className="body">
        <div className="title">教育実施状況確認</div>
        <div className="searchInfo">
          <FormikProvider value={formik}>
            <Form layout="vertical" className="form">
              <span className="titleInfo">&lt;検索条件&gt;</span>
              <div className="full-width">
                <div>新規入場者教育実施状況</div>
                <Form.Item className="checkBoxStyle" name="newCheNot">
                  <CheckboxField
                    name="newCheNot"
                    // onClick={() => checkChange('newCheNot', true)}
                  >
                    未実施
                  </CheckboxField>
                </Form.Item>
                <Form.Item className="checkBoxStyle" name="newCheImp">
                  <CheckboxField
                    name="newCheImp"
                    // onClick={() => checkChange('newCheImp', true)}
                  >
                    実施済
                  </CheckboxField>
                </Form.Item>
                <Form.Item className="checkBoxStyle" name="newCheApp">
                  <CheckboxField
                    name="newCheApp"
                    // onClick={() => checkChange('newCheApp', true)}
                  >
                    承認済
                  </CheckboxField>
                </Form.Item>
                <div className="midTitle">送り出し教育実施状況</div>
                <Form.Item className="checkBoxStyle" name="sendCheNot">
                  <CheckboxField
                    name="sendCheNot"
                    // onClick={() => checkChange('sendCheNot', false)}
                  >
                    未実施
                  </CheckboxField>
                </Form.Item>
                <Form.Item className="checkBoxStyle" name="sendCheImp">
                  <CheckboxField
                    name="sendCheImp"
                    // onClick={() => checkChange('sendCheImp', false)}
                  >
                    実施済
                  </CheckboxField>
                </Form.Item>
                <Form.Item className="checkBoxStyle" name="sendCheApp">
                  <CheckboxField
                    name="sendCheApp"
                    // onClick={() => checkChange('sendCheApp', false)}
                  >
                    承認済
                  </CheckboxField>
                </Form.Item>
              </div>
              <div className="form-group">
                <div className="form-col-1">業者コード</div>
                <div className="form-col-2">
                  <Form.Item className="gyosyaCodeStyle" name="gyosyacode" colon={false}>
                    <InputField name="gyosyacode" className="inputGyosya" maxLength={6} />
                  </Form.Item>
                </div>
                <div className="form-col-3">ー</div>
                <div className="form-col-4">
                  <Form.Item className="gyosyaSitenCodeStyle" name="gyosyasitencode" colon={false}>
                    <InputField
                      name="gyosyasitencode"
                      className="inputGyosyaSiten"
                      onChange={gyosyasitencodeChange}
                      value={gyosyasitencodeValue}
                    />
                  </Form.Item>
                </div>
                <div className="form-col-blank"></div>
                <div className="form-col-5">業者名</div>
                <div className="form-col-6">
                  <Form.Item className="gyosyaNameStyle" name="companyname" colon={false}>
                    <InputField name="companyname" className="inputGyosyaname" maxLength={20} />
                  </Form.Item>
                </div>
                <div className="form-col-blank"></div>
                <div className="form-col-7">作業員名</div>
                <div className="form-col-8">
                  <Form.Item className="workerNameStyle" name="workername" colon={false}>
                    <InputField name="workername" className="inputworkername" maxLength={10} />
                  </Form.Item>
                </div>
              </div>
              <div className="form-group">
                <div className="form-col-1">現場コード</div>
                <div className="form-col-2">
                  <Form.Item className="jyuchuCodeStyle" name="jyuchucode" colon={false}>
                    <InputField
                      name="jyuchucode"
                      className="inputJyuChu"
                      value={jyuchucodeValue}
                      onChange={jyuchucodeChange}
                    />
                  </Form.Item>
                </div>
                <div className="form-col-3">ー</div>
                <div className="form-col-4">
                  <Form.Item className="tsuikacodeCodeStyle" name="tsuikacode" colon={false}>
                    <InputField
                      name="tsuikacode"
                      className="inputTsuika"
                      onChange={tsuikacodeChange}
                      value={tsuikacodeValue}
                    />
                  </Form.Item>
                </div>
                <div className="form-col-blank"></div>
                <div className="form-col-5">現場名</div>
                <div className="form-col-6">
                  <Form.Item className="siteNameStyle" name="sitename" colon={false}>
                    <InputField name="sitename" className="inputSitename" maxLength={20} />
                  </Form.Item>
                </div>
                <div className="form-col-9">
                  <div className="subButSty">
                    <ButtonSubmit>検索</ButtonSubmit>
                  </div>
                </div>
              </div>
            </Form>
          </FormikProvider>
        </div>
        <div className="tableSty">
          <div className="allCheckBox">
            <Checkbox onChange={handleCheck} checked={allFlg} disabled={allFlgDis}>
              全選択
            </Checkbox>
          </div>
          <Table
            columns={columns}
            dataSource={dataSourceShow}
            rowKey={rowKey}
            rowSelection={rowSelection}
          />
          <Pagination
            className="pagination"
            current={currentSent}
            onChange={(page) => setCurrent(page)}
            pageSize={pageSize}
            total={dataSource?.length}
            showSizeChanger={false}
          />
          <div className="buttonSty">
            {userRole.BO != roleUser ? (
              <Button
                className={appButtonFlg ? 'leftButtontrue' : 'leftButton'}
                onClick={() => setVisibleApproveRY(true)}
                disabled={appButtonFlg}
              >
                承認
              </Button>
            ) : (
              <div></div>
            )}
            <div className="rightButton">
              <div>＜教育実施＞</div>
              <Button
                onClick={toNewentrantSendoff}
                disabled={buttonFlg}
                className={buttonFlg ? '' : 'newOrSendBtn'}
              >
                新規・送出
              </Button>
            </div>
          </div>
        </div>
      </div>
    </EducationStatusStyled>
  );
};
export default EducationStatus;

const initialValues = {
  newCheNot: false,
  newCheImp: false,
  newCheApp: false,
  sendCheNot: false,
  sendCheImp: false,
  sendCheApp: false,
  gyosyacode: '',
  gyosyasitencode: '',
  companyname: '',
  workername: '',
  jyuchucode: '',
  tsuikacode: '',
  sitename: '',
};
// 2023/12/25 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end
